// extracted by mini-css-extract-plugin
export default {"tab":"TabBar_tab__CM0Sl","line":"TabBar_line__-yFKp","box":"TabBar_box__+PNbY","item":"TabBar_item__kv8Az","active":"TabBar_active__ym4YN"};